module.exports = __webpack_public_path__ + "img/television.ac6a005f.svg";